import {
  borderRadius,
  Icon,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
  background-color: var(--background-soft);
  border: 1px solid var(--border-soft);
  ${borderRadius.r2}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h3`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin: 0;
`;

export const ExpandButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  ${borderRadius.r2};
  border: 1px solid var(--border-default);
  background: transparent;
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }
`;

export const ExpandIcon = styled(Icon)`
  color: var(--text-default);
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;
`;

export const MetricContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MetricLabel = styled.span`
  ${typographyV2.titleSm}
  color: var(--text-soft);
`;

export const MetricValue = styled.span`
  ${typographyV2.bodyBase}
  color: var(--text-default);
`;

type MetricValueMonoVariant = 'default' | 'positive' | 'negative';

const getMetricValueColor = (variant: MetricValueMonoVariant) => {
  switch (variant) {
    case 'positive':
      return 'var(--viz-bullish)';
    case 'negative':
      return 'var(--viz-bearish)';
    default:
      return 'var(--text-default)';
  }
};

export const MetricValueMono = styled.span<{
  $variant?: MetricValueMonoVariant;
}>`
  font-family: var(--font-roboto-mono);
  font-size: 18px;
  line-height: 24px;
  color: ${({ $variant = 'default' }) => getMetricValueColor($variant)};
`;

export const CurrencyLabel = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-default);
  margin-left: 4px;
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TimeIcon = styled(Icon)`
  color: var(--text-soft);
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        height: '100px',
        width: '100%',
        borderRadius: '8px',
      },
    },
  ],
})``;
